// extracted by mini-css-extract-plugin
export var blue = "_29-g";
export var brand = "_29-c";
export var darkGrey = "_29-f";
export var disabled = "_29-6";
export var disabledSubtle = "_29-7";
export var error = "_29-8";
export var green = "_29-h";
export var grey = "_29-e";
export var icon = "_29-0";
export var inherit = "_29-b";
export var lightGrey = "_29-d";
export var orange = "_29-j";
export var pink = "_29-l";
export var primary = "_29-1";
export var purple = "_29-m";
export var quaternary = "_29-4";
export var quinary = "_29-5";
export var red = "_29-k";
export var secondary = "_29-2";
export var success = "_29-a";
export var tertiary = "_29-3";
export var warning = "_29-9";
export var white = "_29-n";
export var yellow = "_29-i";